import React, { useCallback } from 'react';
import { useTranslate } from 'nucleus-text';
import { useRouter } from 'next/router';
import { Button } from '@cvent/carina/components/Button';

import { useSsoLogin } from '@components/providers/FormDisplayProvider';
import { useAlert } from '@components/providers/ErrorProvider';

export const SsoButton = ({ testID }): JSX.Element => {
  const router = useRouter();
  const { translate } = useTranslate();
  const { updateSsoLogin } = useSsoLogin();
  const { updateAlert } = useAlert();

  const switchToSsoLogin = useCallback(async (): Promise<void> => {
    delete router.query.sourceProductId;
    await router.push({ pathname: '/multiproductauth', query: { ...router.query } }, undefined, { shallow: true });

    updateSsoLogin(true);
    updateAlert({});
  }, [router, updateAlert, updateSsoLogin]);

  return (
    <Button
      testID={`${testID}_ssoLogin`}
      text={translate('redirect_loginSSO__resx')}
      type={'button'}
      size={'l'}
      appearance={'lined'}
      onClick={switchToSsoLogin}
      isBlock
    />
  );
};

export default SsoButton;
